import getSelectedMediaElementsObjects from 'editor/src/store/design/selector/getSelectedMediaElementsObjects';
import { MediaText } from 'editor/src/store/design/types';
import isPersonalizationLockIgnored from 'editor/src/store/editor/selector/isPersonalizationLockIgnored';
import { RootState } from 'editor/src/store/index';

/**
 * The text a library entry is added to instead of becoming a new text: the one selected text, when the customer may
 * change its content. This is how a template's prepared frame (e.g. a fixed hymn frame in the hymn style) fills up
 * one entry after another.
 */
const getTextLibraryAppendTarget = (state: RootState): MediaText | undefined => {
  const selected = getSelectedMediaElementsObjects(state);
  const [element] = selected;
  if (selected.length !== 1 || element?.type !== 'text') {
    return undefined;
  }
  if (
    element.locked ||
    element.uneditable ||
    element.extra.variableColumn ||
    (element.personalizationLocked && !isPersonalizationLockIgnored(state))
  ) {
    return undefined;
  }
  return element;
};

export default getTextLibraryAppendTarget;
